
import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(false)
  const [initialLoadComplete, setInitialLoadComplete] = React.useState(false)

  React.useEffect(() => {
    // Check if window is available (client-side)
    if (typeof window !== 'undefined') {
      const checkMobile = () => {
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
      }
      
      // Initial check
      checkMobile()
      setInitialLoadComplete(true)
      
      // Add event listener for resize
      window.addEventListener('resize', checkMobile)
      
      // Clean up event listener
      return () => window.removeEventListener('resize', checkMobile)
    }
  }, [])

  // Return false during initial server render, then actual value after effect runs
  return initialLoadComplete ? isMobile : false
}
